import { createTRPCClient, httpBatchLink } from "@trpc/client";
import SuperJSON from "superjson";
import urlJoin from "url-join";
export const createTrpcClient = ({
  serverUrl
}) => {
  return createTRPCClient({
    links: [httpBatchLink({
      url: urlJoin(serverUrl, "trpc"),
      transformer: SuperJSON,
      fetch(url, options) {
        return fetch(url, {
          ...options,
          /**
           * https://trpc.io/docs/client/cors
           *
           * This is required if you are deploying your frontend (web)
           * and backend (server) on two different domains.
           */
          credentials: "include"
        });
      }
    })]
  });
};